import {HistoryItem} from '../components/History';

export type I18NMultiple = {
	single: string;
	multiple: string;
}


/* eslint-disable camelcase */
interface I18nType {
	check_all: string;
	click_to_fix: string;
	close: string;
	closeHistory: string;
	could_not_run: string;
	date: string;
	fail: string;
	failed: string;
	fix: string;
	goLive: string;
	history: string;
	history_description: string;
	history_empty: string;
	newUrl: string;
	oldUrl: string;
	only_sections: string;
	only_tables: string;
	pass: string;
	safeToUpdate: string;
	searching: string;
	sections: string;
	something_wrong: string;
	status: string;
	successfullyUpdated: I18NMultiple;
	tables: string;
	test_button_instructions: string;
	test_results: string;
	uncheck_all: string;
	unknown: string;
	updated: I18NMultiple;
	updating: string;
	updateUrls: string;
	use: string;
	use_sections: string;
	use_tables: string;
	use_this_history: string;
	willUpdate: I18NMultiple;
}

export interface Section {
	label: string;
	tables: string[];
}

interface JSConfig {
	endpoint: {
		actions: {
			countUrls: string;
			getResults: string;
			getFixedUrl: string;
			updateUrls: string;
		},
		ajaxURL: string;
		globalNonce: string;
	};
	fields: {
		countOnly: string;
		newUrl: string;
		oldUrl: string;
		tables: string;
		tests: {
			fixedUrl: string;
			fixedResults: string;
			old: string;
			new: string;
			testId: string;
		}
	};
	history: HistoryItem[];
	i18n: I18nType;
	isMobile: boolean;
	loading: string;
	newUrl: string;
	oldUrl: string;
	selectors: {
		wrap: string;
	};
	sections: {
		comments: Section;
		custom: Section;
		network: Section;
		options: Section;
		posts: Section;
		terms: Section;
		user: Section;
	};
	siteInfo: {
		basic: string;
		pro: string;
		scriptDebug: boolean;
		wordpress: string;
	}
}

interface WindowInterface {
	GO_LIVE_UPDATE_URLS_PRO: JSConfig
	__TEST__?: boolean;
}

declare let window: WindowInterface;
export const global = window;

export const CONFIG: JSConfig = window.GO_LIVE_UPDATE_URLS_PRO || {} as JSConfig;
export const I18N = CONFIG.i18n || {} as I18nType;
export const ACTIONS = CONFIG.endpoint.actions || {} as JSConfig['endpoint']['actions'];
